import { listenForNotificationChanges } from "@app/firebase/notification";
import { INotification } from "@app/firebase/notification.interfaces";
import { INotificationStorage } from "@app/storage/Notification.interfaces";
import logger from "@app/utils/logger";
import { DateTime } from "luxon";
import { makeObservable, observable, runInAction } from "mobx";

class NotificationStorage implements INotificationStorage {
  notifications: INotification[] = [];
  _unsubscribe: (() => void) | null = null;

  constructor() {
    makeObservable(this, {
      notifications: observable,
      _unsubscribe: observable,
    });

    window.onbeforeunload = () => {
      this.unsubscribe();
    };

    window.addEventListener("beforeunload", () => {
      this.unsubscribe();
    });
  }

  subscribe = () => {
    const unsubscribe = listenForNotificationChanges((snapshot) => {
      try {
        runInAction(() => {
          this.notifications = snapshot.docs.map(
            (x) =>
              ({
                ...x.data(),
                id: x.id,
                date: DateTime.fromISO(x.data().date),
              }) as INotification,
          );
        });
      } catch (err) {
        logger.error("Error in notification listener", err);
      }
    });
    runInAction(() => {
      this._unsubscribe = unsubscribe;
    });
  };

  unsubscribe = () => {
    if (this._unsubscribe !== null) {
      this._unsubscribe();
    }
    runInAction(() => {
      this._unsubscribe = null;
    });
    this.clear();
  };

  clear = () => {
    runInAction(() => {
      this.notifications = [];
    });
  };
}

const notificationStorage = new NotificationStorage();
export default notificationStorage;
